const isValidLoadWidgetCall = (element, options) => {
  // check mandatory params
  const { type, id, filters = {} } = options
  const { website, platform } = filters
  let isValid = true
  if (
    !element ||
    !((type && (id || (website && platform))) || options.widgetFeed)
  ) {
    // #todo: console on prod and alert on dev show error msg
    isValid = false
  }

  return isValid
}
export default { isValidLoadWidgetCall }
